import { addNewAnalysis } from "api/Finances";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";


export const useAddAnalysis = () => {
    const queryClient = useQueryClient();
    return useMutation(addNewAnalysis, {
        onSuccess: () => {
            toast.success("Added sucesfully");
            queryClient.invalidateQueries('analysisCost');
        },
        onError: () => {
            toast.error("Something went wrong! Please try again later.");
        },
    })
}